import { useMemo } from 'react'

import { ListCampaignsApiArg } from '@/__generated/es-api'

import { useGetCampaigns } from './use-get-campaigns'

export const useGetCampaignOptions = (query: Omit<ListCampaignsApiArg, 'orgId'>) => {
  const result = useGetCampaigns(query)

  const data = useMemo(() => {
    if (!result.data?.engagements) {
      return []
    }
    return result.data.engagements.map((item: any) => ({
      label: `${item.name} - ${item.id}`,
      value: item.id,
    }))
  }, [result.data])

  return {
    ...result,
    data,
  }
}
